import { render, staticRenderFns } from "./CreditBooksTypeForm.vue?vue&type=template&id=c305070c&scoped=true"
import script from "./CreditBooksTypeForm.vue?vue&type=script&lang=js"
export * from "./CreditBooksTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c305070c",
  null
  
)

export default component.exports